import $ from '@nuskin/nuskinjquery';
import ScrollUtil from './scrollUtil.js';
import SectionEnum from './sectionEnum.js';
import {PersonalOfferService} from '@nuskin/ns-shop';

const SectionUtil = function() {
    'use strict';

    let $scope;
    let $timeout;
    let nsPersonalOfferStep;

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    const publicMethods = {
        initSections: function(scope, nsSections, timeoutService) {
            nsPersonalOfferStep = PersonalOfferService;
            $scope = scope;
            $timeout = timeoutService;
            $scope.sections = nsSections.create();
            $scope.sections.hasValidationErrors = hasValidationErrors;
            $scope.isChosenElementBusy = isChosenElementBusy;
            $scope.isChosenElementValid = isChosenElementValid;

            $scope.$watch('sections.adrOptions.edit', function() {
                // Force a reflow to ensure the contents are visible
                // Hack to fix iOS rendering issues with DIVs/iFrames being cut off
                if ($scope.sections.adrOptions.edit == true) {
                    $timeout(function() {
                        $('.tncContainer').hide().show(0);
                    }, 2000);
                }
            });

            /**
             continueEdit is called when a user clicks the continue button of a section.
             This method makes sure the section is complete before opening the next unmodified section
             */
            $scope.continueEdit = continueEdit;

            /**
             updateEdit called when you click edit on a section in the UI
             This method will open the appropriate section and close any other open sections
             It will also displa errorMessages if needed
             */
            $scope.updateEdit = updateEdit;
        }
    };
    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------
    function hasValidationErrors() {
        let isShowingCcv;
        if ($scope.order.selectedPayment) {
            isShowingCcv = $scope.isShowingCcv($scope.order.selectedPayment.paymentTypeId);
        }
        return isShowingCcv && $scope.forms.ccvform.$invalid;
    }
    function isChosenElementBusy(element) {
        return ($scope.isBusy && ($scope.chosen.element != null) && ($scope.chosen.element == element));
    }
    function isChosenElementValid(element) {
        return (($scope.chosen.element != null) && ($scope.chosen.element == element) && $scope.chosen.isValid);
    }
    function continueEdit(fromSection, disabled = false) {
        if (disabled) return;

        $scope.sections[fromSection].error.infoMessages = [];

        // check for validation errors
        if (fromSection == SectionEnum.ADROPTIONS && !$scope.adrTncCheckbox) {
            flashAgreeToTerms('tncComboCheckboxText', 'adrAgree2Terms');
        } else {
            // if there are not errors or there are only info errors
            if (!$scope.sections.hasErrorMessages()) {
                $scope.sections[fromSection].edit = false;
                // go to first non pristine section
                if ($scope.sections.shipmethod.pristine) {
                    $scope.sections.shipmethod.edit = true;
                    $scope.sections.shipmethod.pristine = false;
                } else if ((($scope.adr && $scope.adr.shipImmediate) || $scope.order.adr) && $scope.sections.adrOptions.pristine) {
                    // AdrUtil.initAdrSection();
                    $scope.sections.adrOptions.edit = true;
                    $scope.sections.adrOptions.pristine = false;
                } else if ($scope.sections.review.pristine) {
                    $scope.sections.review.edit = true;
                    $scope.sections.review.pristine = false;
                }
                if ($scope.isPitchCart) {
                    handlePersonalOffersStep(fromSection);
                }
                // In the shipping section they might scroll to select a shipping address so we need to make sure to autoscroll back
                if (fromSection === SectionEnum.SHIPPING) {
                    ScrollUtil.scrollToSection(fromSection);
                    // ScrollUtil.scrollToNextSection(fromSection, $scope.adrOptions !== null && $scope.adrOptions !== undefined);
                }
            } else {
                $scope.sections.openErrorSections();
            }
        }
    }

    function handlePersonalOffersStep(fromSection) {
        switch (fromSection) {
            case SectionEnum.SHIPPING:
                nsPersonalOfferStep.callPayment($scope.personalOffer.sapId, $scope.personalOffer.pitchID);
                break;
            case SectionEnum.PAYMENT:
                nsPersonalOfferStep.callReview($scope.personalOffer.sapId, $scope.personalOffer.pitchID);
                break;
        }
    }

    function updateEdit(section) {
        // Section is the section the edit button was clicked
        // If the order is busy that means we are doing a simulate.  In this case don't push error.
        if ($scope.sections.cart.edit && $scope.sections.cart.modified) {
            $scope.simulateOrder().then(function() {
                $scope.chosen.isValid = true;
                $timeout(function() {
                    $scope.chosen.isValid = false;
                    $scope.sections.closeSections();
                    $scope.sections[section].edit = true;
                    // ScrollUtil.scrollToSection(section);
                }, 1500);
                $scope.sections.cart.modified=false;
            });
        } else {
            if ($scope.sections.shipping.edit && !$scope.sections.shipping.isSelected() && !$scope.isBusy) {
                // $scope.sections.shipping.error.addErrorMessage("error",{text:$scope.tdc.selectShippingAddressErrorMessage});
                $scope.sections.shipping.pristine = true;
            } else if ($scope.sections.shipmethod.edit && $scope.shouldSelectPickupPoint() && !$scope.isBusy) {
                $scope.sections.shipmethod.pristine = true;
            } else if ($scope.sections.adrOptions && $scope.sections.adrOptions.edit && !$scope.adrTncCheckbox) {
                $scope.sections.adrOptions.pristine = true;
            }

            // User can change sections
            $scope.sections.cart.edit = false;
            $scope.sections.shipping.edit = false;
            $scope.sections.shipmethod.edit = false;
            $scope.sections.payment.edit = false;
            if ($scope.sections.adrOptions) {
                $scope.sections.adrOptions.edit = false;
            }
            $scope.sections.review.edit = false;
            $scope.sections[section].edit = true;

            // If we are editing the payment section and there is no default payment we go to select payment mode.
            if (section === SectionEnum.PAYMENT && (!$scope.order.selectedPayment || $scope.order.selectedPayment.paymentTypeId === undefined)) {
                $scope.sections.payment.selecting=true;
            }

            // ScrollUtil.scrollToSection(section);
        }
    }
    function flashAgreeToTerms(textId, agree2TermsId) {
        const textIdEle = $(`.${textId}`);
        if (textIdEle.length > 0) {
            textIdEle.css('color', 'red');
        } else {
            $('#' + textId).css('color', 'red');
        }

        const agree2TermsIdEle = $(`.${agree2TermsId}`);
        // Flash three times.
        for (let i = 0; i < 3; i++) {
            if (agree2TermsIdEle.length > 0) {
                agree2TermsIdEle.fadeTo('slow', 0.2).fadeTo('slow', 1.0);
            } else {
                $('#' + agree2TermsId).fadeTo('slow', 0.2).fadeTo('slow', 1.0);
            }
        }
    }

    return publicMethods;
}();

export default SectionUtil;
